import script from "./schema-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./schema-form.vue?vue&type=script&lang=ts&setup=true"

import "./schema-form.vue?vue&type=style&index=0&id=6cd9bf00&lang=css"

const __exports__ = script;

export default __exports__